// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3axrH","name":"ConsentHeader_name__1-1FK","birthday":"ConsentHeader_birthday__126Jg","skeleton":"ConsentHeader_skeleton__1MAzN"};